"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7633],{

/***/ 472327:
/***/ (function(module) {



function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable @typescript-eslint/no-var-requires */
/** Delimiter to be used for separating child properties */
var CHILD_DELIMITER = "-";

/** Child properties starting with this, will be available directly like color-primary, instead of color-primary-main */
var DEFAULT_CHILDREN = "__";
var DESCRIPTION_PROPERTY = "__description";

/**
 * @typedef {{key: keyName, value: obj}} CssVariable
 */

var isPrimitive = function isPrimitive(value) {
  return ["string", "number", "boolean"].includes(_typeof(value));
};
var parseThemeObject = function parseThemeObject(theme) {
  /**
   * @type {CssVariable[]}
   */
  var cssVariables = [];
  var parseRecursively = function parseRecursively(obj) {
    var keyPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (isPrimitive(obj)) {
      // primitive
      var keyName = keyPath.join(CHILD_DELIMITER);
      var thisKey = keyPath.pop();
      if (thisKey === DEFAULT_CHILDREN) {
        keyName = keyPath.join(CHILD_DELIMITER);
      }
      cssVariables.push({
        key: keyName,
        value: obj
      });
      return;
    }
    Object.entries(obj).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (Array.isArray(value)) {
        value.forEach(function (singleVal, index) {
          return parseRecursively(singleVal, [].concat(_toConsumableArray(keyPath), [key, index]));
        });
      }
      parseRecursively(value, [].concat(_toConsumableArray(keyPath), [key]));
    });
  };
  parseRecursively(theme);
  return cssVariables;
};

/**
 * Get Line to be injected in CSS/Scss
 * @param {String} key
 * @param {String} value
 * @param {'css' | 'scss'} type
 */
var getVariableLine = function getVariableLine(key, value) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "css";
  if (key.includes(DESCRIPTION_PROPERTY)) {
    return "/* ".concat(value, " */");
  }
  if (type === "css") {
    key = "--".concat(key);
  }
  if (type === "scss") {
    key = "$".concat(key);
    value = JSON.stringify(value || "");
  }
  return "".concat(key, ": ").concat(value || '""', ";");
};

/**
 *
 * @param {CssVariable[]} cssVariables
 * @returns css-variables surrounded by :root
 */
var getCssContent = function getCssContent(cssVariables) {
  var cssVariablesStr = cssVariables.map(function (_ref3) {
    var key = _ref3.key,
      value = _ref3.value;
    return getVariableLine(key, value, "css");
  }).join("\n  ");
  cssVariablesStr = ":root{\n  ".concat(cssVariablesStr, "\n}");
  return cssVariablesStr;
};
var getScssContent = function getScssContent(cssVariables) {
  var scssVariablesStr = cssVariables.map(function (_ref4) {
    var key = _ref4.key,
      value = _ref4.value;
    return getVariableLine(key, value, "scss");
  }).join("\n");
  return scssVariablesStr;
};
var getCssFromThemeObject = function getCssFromThemeObject(theme) {
  var cssVariables = parseThemeObject(theme);
  return getCssContent(cssVariables);
};
module.exports = {
  getCssContent: getCssContent,
  getScssContent: getScssContent,
  getCssFromThemeObject: getCssFromThemeObject,
  parseThemeObject: parseThemeObject
};

/***/ }),

/***/ 952301:
/***/ (function(module) {



function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable no-undef */

var colors = {
  accent: {
    100: "#D8E5FE",
    200: "#B1C9FE",
    300: "#8AABFE",
    400: "#6D92FD",
    500: "#3D6AFD",
    600: "#2C50D9",
    700: "#1E3AB6",
    800: "#132892",
    900: "#0B1A79"
  },
  success: {
    100: "#F1FBD1",
    200: "#E1F8A4",
    300: "#C5EC73",
    400: "#A7D94E",
    500: "#7FC11D",
    600: "#65A515",
    700: "#4E8A0E",
    800: "#3A6F09",
    900: "#2B5C05"
  },
  warning: {
    100: "#FFFAD6",
    200: "#FFF4AD",
    300: "#FFEC83",
    400: "#FFE565",
    500: "#FFD932",
    600: "#DBB524",
    700: "#B79419",
    800: "#93730F",
    900: "#7A5C09"
  },
  danger: {
    100: "#FFE7D5",
    200: "#FFCAAB",
    300: "#FFA581",
    400: "#FF8261",
    500: "#FF492D",
    600: "#DB2B20",
    700: "#B7161A",
    800: "#930E1C",
    900: "#7A081D"
  }
};
var spacing = {
  __description: "Spacing",
  0: "0",
  2: "0.125rem",
  4: "0.25rem",
  8: "0.5rem",
  12: "0.75rem",
  16: "1rem",
  20: "1.25rem",
  24: "1.5rem",
  32: "2rem",
  40: "2.5rem",
  48: "3rem",
  56: "3.5rem",
  64: "4rem",
  80: "5rem"
};
var shadows = {
  0: "none",
  1: "0 0.0625rem 0.1875rem rgba(0,0,0,0.12), 0 0.0625rem 0.125rem rgba(0,0,0,0.24)",
  2: "0 0.125rem 0.25rem rgba(0,0,0,0.14), 0 0.125rem 0.1875rem rgba(0,0,0,0.22)",
  3: "0 0.1875rem 0.3125rem rgba(0,0,0,0.16), 0 0.1875rem 0.25rem rgba(0,0,0,0.20)",
  4: "0 0.25rem 0.375rem rgba(0,0,0,0.18), 0 0.25rem 0.3125rem rgba(0,0,0,0.18)",
  5: "0 0.3125rem 0.4375rem rgba(0,0,0,0.20), 0 0.3125rem 0.375rem rgba(0,0,0,0.16)",
  6: "0 0.375rem 0.5rem rgba(0,0,0,0.22), 0 0.375rem 0.4375rem rgba(0,0,0,0.14)",
  7: "0 0.4375rem 0.5625rem rgba(0,0,0,0.24), 0 0.4375rem 0.5rem rgba(0,0,0,0.12)",
  8: "0 0.5rem 0.625rem rgba(0,0,0,0.26), 0 0.5rem 0.5625rem rgba(0,0,0,0.10)"
};
var theme = {
  theme: "dark",
  screens: {
    lg: "768px"
  },
  spacing: spacing,
  color: {
    __description: "Color palette",
    primary: {
      __: "#111111",
      main: "#111111",
      hover: "#181818",
      active: "#080808",
      disabled: "#525252",
      bgLight: "#EEEEEE"
    },
    accent: {
      __: colors.accent[800],
      main: colors.accent[800],
      hover: colors.accent[700],
      active: colors.accent[900],
      disabled: colors.accent[500],
      bgLight: colors.accent[200]
    },
    success: {
      __: colors.success[800],
      main: colors.success[800],
      hover: colors.success[700],
      active: colors.success[900],
      disabled: colors.success[500],
      bgLight: colors.success[200]
    },
    warning: {
      __: colors.warning[700],
      main: colors.warning[700],
      hover: colors.warning[600],
      active: colors.warning[800],
      disabled: colors.warning[400],
      bgLight: colors.warning[200]
    },
    danger: {
      __: colors.danger[700],
      main: colors.danger[700],
      hover: colors.danger[600],
      active: colors.danger[800],
      disabled: colors.danger[400],
      bgLight: colors.danger[200]
    }
  },
  borderRadius: {
    __description: "Shapes",
    none: "0",
    sm: "0.125rem",
    md: "0.375rem",
    lg: "0.5rem",
    full: "100rem"
  },
  typography: {
    __description: "Typography & Fonts",
    fontFamily: "",
    fontFamilyCode: "",
    fontFamilyTagline: "",
    fontFamilySystem: "",
    fontWeightSemiBold: 600,
    fontWeightExtraBold: 800,
    h1: {
      fontFamily: "",
      fontSize: "clamp(2.625rem, 1.2857rem + 3.5714vw, 4rem)",
      fontWeight: 800,
      lineHeight: 1.1142857142857143
    },
    h2: {
      fontFamily: "",
      fontSize: "clamp(1.5rem, 0.9643rem + 1.4286vw, 2.25rem)",
      fontWeight: 800,
      lineHeight: 1.2222222222222223,
      color: "#132F4C"
    },
    h3: {
      fontFamily: "",
      fontSize: "2.25rem",
      lineHeight: 1.2222222222222223,
      letterSpacing: 0.2,
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h4: {
      fontFamily: "",
      fontSize: "1.75rem",
      lineHeight: 1.5,
      letterSpacing: 0.2,
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h5: {
      fontFamily: "",
      fontSize: "1.5rem",
      lineHeight: 1.5,
      letterSpacing: 0.1,
      color: "#007FFF",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    h6: {
      fontSize: "1.25rem",
      lineHeight: 1.5,
      fontFamily: "",
      fontWeight: 500,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    button: {
      textTransform: "initial",
      fontWeight: 700,
      letterSpacing: 0,
      fontFamily: "",
      fontSize: "0.875rem",
      lineHeight: 1.75,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    subtitle1: {
      fontSize: "1.125rem",
      lineHeight: 1.3333333333333333,
      letterSpacing: 0,
      fontWeight: 500,
      fontFamily: "",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: "",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontFamily: "",
      fontWeight: 400,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    caption: {
      display: "inline-block",
      fontSize: "0.75rem",
      lineHeight: 1.5,
      letterSpacing: 0,
      fontWeight: 700,
      fontFamily: "",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    allVariants: {
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    htmlFontSize: 16,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    subtitle2: {
      fontFamily: "",
      fontWeight: 500,
      fontSize: "0.875rem",
      lineHeight: 1.57,
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    },
    overline: {
      fontFamily: "",
      fontWeight: 400,
      fontSize: "0.75rem",
      lineHeight: 2.66,
      textTransform: "uppercase",
      scrollMarginTop: "calc(var(--MuiDocs-header-height) + 32px)"
    }
  },
  shadows: _objectSpread(_objectSpread({}, shadows), {}, {
    appBar: shadows["3"],
    fab: shadows["5"]
  }),
  transition: {
    __description: "Animations timings",
    easing: {
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
      easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
    },
    duration: {
      s: 100,
      m: 250,
      l: 500
    }
  },
  zIndex: {
    mobileStepper: 1000,
    fab: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
  }
};
module.exports = {
  theme: theme,
  colors: colors
};

/***/ }),

/***/ 692687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _404Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
;// CONCATENATED MODULE: ./src/assets/svgExports/SearchIcon404.js


var SearchIcon404 = function(param) {
    var height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 201 200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m132.534 99.053-33.146 33.144s11.787-3.681 28.728 2.209c2.85.991 7.618-3.778 6.628-6.628-5.891-16.94-2.21-28.725-2.21-28.725",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F7F7F7",
                fillRule: "evenodd",
                d: "M43.825 43.488c20.125-20.122 52.797-20.122 72.922 0 20.122 20.124 20.122 52.796 0 72.921-20.125 20.122-52.797 20.122-72.922 0-20.122-20.125-20.122-52.797 0-72.922",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M110.081 37.856a52 52 0 0 1 6.666 5.631c20.122 20.125 20.122 52.797 0 72.922-20.125 20.122-52.797 20.122-72.922 0a53 53 0 0 1-3.347-3.681c19.506 6.338 41.8 1.763 57.288-13.725 16.518-16.519 20.625-40.781 12.315-61.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M39.406 39.069c22.563-22.563 59.197-22.563 81.76 0 22.562 22.562 22.562 59.197 0 81.759-22.563 22.563-59.197 22.563-81.76 0-22.562-22.562-22.562-59.197 0-81.76m6.628 6.628c18.904-18.903 49.6-18.903 68.504 0 18.903 18.903 18.903 49.6 0 68.503-18.904 18.903-49.6 18.903-68.504 0-18.903-18.903-18.903-49.6 0-68.503",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M28.49 105.656c-10.724-21.622-7.087-48.584 10.916-66.587 16.907-16.906 41.713-21.144 62.585-12.713a74.5 74.5 0 0 1 .09 10.325c-18.16-9.143-40.89-6.137-56.047 9.016-16.065 16.066-18.478 40.65-7.23 59.275-3.295.45-6.657.684-10.07.684z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l45.3 45.3c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l41 41c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M73.666 70.11c-.072-2.979 1.047-5.154 2.772-6.429 2.712-2 6.765-1.915 8.965.563.944 1.065 1.49 2.572 1.506 4.478.038 4.572-2.106 7.244-4.206 10.01-2.825 3.727-5.647 7.559-5.997 13.956a3.127 3.127 0 0 0 6.244.34c.263-4.86 2.587-7.69 4.734-10.522 2.875-3.79 5.529-7.572 5.475-13.834-.03-3.681-1.259-6.522-3.084-8.578-4.263-4.8-12.09-5.319-17.347-1.444-3.15 2.325-5.44 6.175-5.312 11.606a3.127 3.127 0 0 0 6.25-.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                d: "M79.538 107.584a3.844 3.844 0 1 0 0-7.687 3.844 3.844 0 0 0 0 7.687"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m135.775 26.553 9.375-15.625a3.124 3.124 0 1 0-5.359-3.216l-9.375 15.625a3.125 3.125 0 1 0 5.359 3.216M150.559 36.85l34.375-25a3.13 3.13 0 0 0 .691-4.366 3.13 3.13 0 0 0-4.366-.69l-34.375 25a3.127 3.127 0 0 0 3.675 5.056M155.728 56.103l25-6.25a3.126 3.126 0 1 0-1.515-6.062l-25 6.25a3.124 3.124 0 0 0 1.515 6.063",
                clipRule: "evenodd"
            })
        ]
    });
};
/* harmony default export */ var svgExports_SearchIcon404 = (SearchIcon404);

// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(254051);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
;// CONCATENATED MODULE: ./src/containers/404Page/ErrorMsg.tsx







var ErrorMsg = function() {
    var store = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store
        };
    }).store;
    var isDesktop = (0,getWindowDimension/* default */.Z)().isDesktop;
    var ref = function() {
        var size = isDesktop ? 200 : 100;
        return {
            height: size,
            width: size
        };
    }(), height = ref.height, width = ref.width;
    var goToHomePage = function() {
        (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store === null || store === void 0 ? void 0 : store.domain);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-static tw-flex tw-flex-col tw-bg-white ".concat(isDesktop ? "tw-my-[78px] tw-gap-[60px]" : "tw-my-[138px] tw-gap-[48px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-center ".concat(isDesktop ? "tw-gap-[40px]" : "tw-gap-[32px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_SearchIcon404, {
                        height: height,
                        width: width
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "msg tw-flex tw-flex-col tw-gap-16 tw-text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-font-inter tw-text-[22px]/[32px] tw-font-semibold tw-text-[#000000] md:tw-text-[32px]/[44px] md:tw-font-semibold",
                                children: "Uh oh, this page does not exist."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-font-inter tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-[#00000099] md:tw-text-[18px]/7",
                                children: [
                                    "You may have mistyped the address or the ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " page may have been removed."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: goToHomePage,
                    className: "tw-mx-auto tw-w-[90%] tw-cursor-pointer tw-rounded-lg tw-border-none tw-bg-[#2B74D8] tw-px-24 tw-py-10 tw-font-inter tw-text-[14px] tw-font-semibold tw-leading-8 tw-text-white md:tw-w-auto md:tw-text-[16px]",
                    children: "Go to home page"
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page_ErrorMsg = (ErrorMsg);

// EXTERNAL MODULE: ./src/utils/ssrCommonApiCall.ts + 1 modules
var ssrCommonApiCall = __webpack_require__(122987);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
;// CONCATENATED MODULE: ./src/containers/404Page/index.tsx









var Error404 = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react.useEffect)(function() {
        (0,ssrCommonApiCall/* ssrDataCall */.z)([
            "collections",
            "categories",
            "seo"
        ], storeInfo).then(function(data) {
            dispatch((0,catalog/* saveCatalogCategories */.FF)((data === null || data === void 0 ? void 0 : data.catalogCategories) || []));
            dispatch((0,catalog/* saveCollections */.VN)((data === null || data === void 0 ? void 0 : data.collections) || []));
            dispatch((0,catalog/* saveCatalogTags */.Vj)((data === null || data === void 0 ? void 0 : data.catalogTags) || []));
        });
    }, [
        storeInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ErrorPage_wrapper",
        children: [
            (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_404Page_ErrorMsg, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "EroorPage_body_wrapper",
                children: (ref3 = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Footer) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                    return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page = (Error404);


/***/ }),

/***/ 982381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils_themeImports__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(353978);
/* harmony import */ var _utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(698616);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(268037);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(730381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);







var BlogPage = function(props) {
    var BlogTitleAndAuthorDetails = function BlogTitleAndAuthorDetails() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "tw-mb-40 tw-mt-40 tw-flex tw-flex-col",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "tw-m-0 tw-mb-16 tw-text-[#000]",
                    children: blogData === null || blogData === void 0 ? void 0 : blogData.page_name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "tw-flex tw-flex-col tw-gap-8",
                    children: [
                        !!(blogData === null || blogData === void 0 ? void 0 : blogData.author) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "tw-m-0 tw-text-sm tw-font-bold tw-text-[#555D70]",
                            children: [
                                "By ",
                                blogData.author
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-gap-8 tw-text-12 tw-font-normal tw-text-[#555D70]",
                            children: [
                                !!(blogData === null || blogData === void 0 ? void 0 : blogData.updated_at) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: moment__WEBPACK_IMPORTED_MODULE_5___default()(blogData === null || blogData === void 0 ? void 0 : blogData.updated_at).format("D MMM YYYY")
                                }),
                                !!(blogData === null || blogData === void 0 ? void 0 : blogData.reading_time) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tw-size-[4px] tw-rounded-full tw-bg-[#555D70]"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            children: [
                                                blogData === null || blogData === void 0 ? void 0 : blogData.reading_time,
                                                " minute",
                                                (blogData === null || blogData === void 0 ? void 0 : blogData.reading_time) > 1 ? "s" : "",
                                                " ",
                                                "read"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var BlogHtmlContent = function BlogHtmlContent(param) {
        var htmlData = param.htmlData;
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), processedHTML = ref[0], setProcessedHTML = ref[1];
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            if (htmlData) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(htmlData, "text/html");
                doc.querySelectorAll("img").forEach(function(img) {
                    var getAttr = function(attr) {
                        var fallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                        return img.getAttribute(attr) || fallback;
                    };
                    var ref = {
                        src: getAttr("src"),
                        alt: getAttr("alt"),
                        class: getAttr("class"),
                        title: getAttr("title"),
                        href: getAttr("data-href"),
                        linkTarget: getAttr("data-href-target") === "true" ? "_blank" : "_self"
                    }, src = ref.src, alt = ref.alt, className = ref.class, caption = ref.title, href = ref.href, linkTarget = ref.linkTarget;
                    var imgTag = '<img src="'.concat(src, '" alt="').concat(alt, '" class="').concat(className, '">');
                    var figcaptionTag = caption ? "<figcaption>".concat(caption, "</figcaption>") : "";
                    var wrappedImg = href ? '<a href="'.concat(href, '" target="').concat(linkTarget, '" rel="').concat(linkTarget === "_blank" ? "noopener noreferrer" : "", '">').concat(imgTag, "</a>") : imgTag;
                    var figure = document.createElement("figure");
                    figure.innerHTML = "".concat(wrappedImg).concat(figcaptionTag);
                    img.replaceWith(figure);
                });
                setProcessedHTML(doc.body.innerHTML);
            } else {
                setProcessedHTML("");
            }
        }, [
            htmlData
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-mt-40 tw-w-[100%] tw-text-[16px] tw-font-normal tw-leading-[1.7] tw-text-[#242424]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    dangerouslySetInnerHTML: {
                        __html: processedHTML
                    }
                })
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            catalogCategories: state.catalogReducer.categories
        };
    }), storeInfo = ref6.storeInfo, catalogCategories = ref6.catalogCategories;
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), blogData = ref7[0], setBlogData = ref7[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setBlogData(props === null || props === void 0 ? void 0 : props._addPage);
    }, [
        props === null || props === void 0 ? void 0 : props._addPage
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (ref = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_3__/* .specificThemeRender */ .t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    storeData: props.storeInfo,
                    categories: catalogCategories || []
                }, layout));
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "ai__blog__container tw-m-auto tw-my-0 tw-mb-[150px] tw-w-full tw-max-w-[728px] tw-px-16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlogTitleAndAuthorDetails, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BlogHtmlContent, {
                        htmlData: blogData === null || blogData === void 0 ? void 0 : blogData.html_data
                    })
                ]
            }),
            (ref3 = (0,_utils_specificThemeRender__WEBPACK_IMPORTED_MODULE_3__/* .specificThemeRender */ .t)(storeInfo)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Footer) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                return (0,_utils_themeImports__WEBPACK_IMPORTED_MODULE_2__/* .getThemeComponent */ .s)(layout.sub_type, layout.name, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    storeData: storeInfo,
                    categories: catalogCategories || []
                }, layout));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogPage);


/***/ }),

/***/ 254051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ }),

/***/ 698616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ })

}]);